import { render, staticRenderFns } from "./cookiesPolicy.vue?vue&type=template&id=0cf0bb00"
import script from "./cookiesPolicy.vue?vue&type=script&lang=js"
export * from "./cookiesPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports